import { createSlice } from '@reduxjs/toolkit';

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    settings: {}
  },
  reducers: {
    set: (state, action) => {
      state.settings = action.payload;
    }
  }
});

export const { set: setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;